import React from 'react';

var CollapsibleListContext = /*#__PURE__*/React.createContext(null);
var CollapsibleListContextProvider = function CollapsibleListContextProvider(_ref) {
  var expandedItemId = _ref.expandedItemId,
    setExpandedItemId = _ref.setExpandedItemId,
    children = _ref.children;
  return /* @__PURE__ */React.createElement(CollapsibleListContext.Provider, {
    value: {
      expandedItemId: expandedItemId,
      setExpandedItemId: setExpandedItemId
    }
  }, children);
};

export { CollapsibleListContextProvider as C, CollapsibleListContext as a };

import 'wix-rich-content-plugin-collapsible-list/dist/loadable/viewer/es/styles.viewer.min.global.css'